<script setup>
import { formatCpfOuCnpj, isNilOrEmpty } from '~/utils';

const props = defineProps({
  pessoa: {
    type: Object,
    required: true,
  },
});
</script>
<template>
  <div>
    <a-descriptions
      bordered
      style="margin-top: 24px"
      :label-style="{ width: '10%' }"
      :column="1"
    >
      <a-descriptions-item label="Nome">
        <span style="text-transform: uppercase">
          {{ props.pessoa.nome }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="CPF">
        {{ formatCpfOuCnpj(props.pessoa.documento) }}
      </a-descriptions-item>

      <a-descriptions-item label="Sexo">
        {{ props.pessoa.sexoText }}
      </a-descriptions-item>

      <a-descriptions-item label="Estado civil">
        {{ props.pessoa.estadoCivilText }}
      </a-descriptions-item>

      <a-descriptions-item label="RG">
        {{ props.pessoa.rg }}
      </a-descriptions-item>

      <a-descriptions-item label="Emissor">
        {{ props.pessoa.emissor }}
      </a-descriptions-item>

      <a-descriptions-item label="Profissão">
        {{ props.pessoa.profissao }}
      </a-descriptions-item>

      <a-descriptions-item label="Número da CTPS">
        {{ props.pessoa.ctps }}
      </a-descriptions-item>
      <a-descriptions-item label="Série">
        {{ props.pessoa.serie }}
      </a-descriptions-item>
      <a-descriptions-item label="NIT/PIS/PASEP">
        {{ props.pessoa.nitPisPasep }}
      </a-descriptions-item>

      <a-descriptions-item label="Criado por">
        <a-tooltip v-if="!isNilOrEmpty(props.pessoa.criadoPor)">
          <template #title> Ir para página do criador </template>
          <router-link
            :to="`/usuario/${props.pessoa.criadoPor.codigo}`"
            style="text-transform: uppercase"
          >
            {{ props.pessoa.criadoPor.nome }}
          </router-link>
        </a-tooltip>
        <span v-else>SISTEMA</span>
      </a-descriptions-item>
      <a-descriptions-item label="Data criação">
        {{ props.pessoa.dataCriacaoText }}
      </a-descriptions-item>

      <a-descriptions-item
        v-if="!isNilOrEmpty(props.pessoa.justificativaAusenciaDocumento)"
        label="Justificativa ausência do CPF"
      >
        {{ props.pessoa.justificativaAusenciaDocumento }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
